import {
  applyTranslationStartFailureAction,
  handleTranslationStartFailureContract
} from './translationStartFailureDecision.js'

export async function applyTranslationStartFailureFromResult({
  reason,
  localePath,
  router,
  t,
  showWarning,
  showError,
  buildFailureContract,
  applyFailureAction
}) {
  const createContract = typeof buildFailureContract === 'function'
    ? buildFailureContract
    : handleTranslationStartFailureContract
  const executeFailureAction = typeof applyFailureAction === 'function'
    ? applyFailureAction
    : applyTranslationStartFailureAction

  const failureContract = createContract({ reason, localePath })

  await executeFailureAction({
    failureAction: failureContract.failureAction,
    redirectPath: failureContract.redirectPath,
    router,
    localePath,
    t,
    showWarning,
    showError
  })

  return failureContract
}
